<template>
    <b-row>
        <b-col sm="5">
            <b-form-group label-cols-sm="5"
                          :label="$t('createShipment.label.Number of Packages')"
                          label-align-sm="left">
                <b-input-group size="sm">
                    <b-col sm="10">
                        <b-form-input size="sm"
                                      v-model.number="colliCount"
                                      type="number"
                                      :min="1"
                                      :max="99"
                                      name="numberOfPackagesInput"
                                      :class="{
                                'is-invalid': v.shipment.colliDetails.numberOfColli.$error
                            }"
                                      aria-describedby="numberOfColli-feedback"
                                      @update="v.shipment.colliDetails.numberOfColli.$touch()"
                                      @keypress="isNumber" />

                        <b-form-invalid-feedback id="numberOfColli-feedback"
                                                 name="numberOfPackagesInput.error"
                                                 v-if="v.shipment.colliDetails.numberOfColli.$error">
                            <validationBetween fieldName="createShipment.label.Number of Packages"
                                               :fieldValid="v.shipment.colliDetails.numberOfColli.between"
                                               :fieldMin="
                                    v.shipment.colliDetails.numberOfColli.$params.between.min
                                "
                                               :fieldMax="
                                    v.shipment.colliDetails.numberOfColli.$params.between.max
                                " />
                        </b-form-invalid-feedback>
                    </b-col>
                    <b-input-group-append>
                        <div>
                            <requiredIcon />
                        </div>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="4" v-if="display(fieldNames.SHIPMENT_PACKAGING)">
            <b-form-group>
                <b-row>
                    <b-col sm="9">
                        <vSelect :dynamicWidth="true"
                                 label="productName"
                                 :placeholder="'Choose Shipment Packaging'"
                                 :options="listOfCustomerProducts"
                                 v-model="selectedCustomerProduct"
                                 :name="fieldNames.SHIPMENT_PACKAGING" />
                    </b-col>
                    <b-col sm="1">
                        <font-awesome-icon style="margin-top:5px"
                                           icon="edit"
                                           size="lg"
                                           name="shipmentPackagingEdit"
                                           @click="displayEditShipmentPackagingModal" />
                    </b-col>
                    <b-col sm="1">
                        <font-awesome-icon style="margin-top:5px"
                                           icon="plus-circle"
                                           size="lg"
                                           color="#AFCC8B"
                                           name="shipmentPackagingAdd"
                                           @click="addCustomerProductColli" />
                    </b-col>
                </b-row>
            </b-form-group>
        </b-col>
        <b-col sm="3">
            <b-form-group label-cols-sm="7"
                          :label="$t('createShipment.label.Package Dimensions')"
                          label-align-sm="left">
                <b-input-group size="sm">
                    <b-col sm="1">
                        <b-form-checkbox style="margin-top:5px"
                                         class="float-left"
                                         size="sm"
                                         name="packageDimensionsCheckbox"
                                         v-model="showColliDims"></b-form-checkbox>
                    </b-col>
                </b-input-group>
            </b-form-group>
        </b-col>
        <editShipmentPackaging v-if="!isEditShipmentPackaging"
                               :shipmentPackagingToEdit="selectedCustomerProduct"
                               @reloadProducts="reloadProducts" />
    </b-row>
</template>

<script>
    import 'vue-select/dist/vue-select.css';
    import viewOptions from '../mixins/viewOptionsMixin';
    import validationBetween from './Validation/ValidationBetween';
    import { ACTIONS, CREATE_SHIPMENT_PREFIX, GETTERS } from '../store/constants';
    import { FIELD_NAMES } from '../store/nameConstants';
    import { mapState, mapGetters } from 'vuex';
    import requiredIcon from './requiredIcon';
    import vSelect from './vSelect';
    import helpers from '../helper';
    import editShipmentPackaging from './editShipmentPackaging.vue';
    import resetMixin from '../mixins/resetMixin';

    export default {
        components: {
            vSelect,
            requiredIcon,
            validationBetween,
            editShipmentPackaging: editShipmentPackaging
        },

        props: {
            shipment: {
                required: true,
            },
            v: { required: true },
            isEditShipmentPackaging: { type: Boolean, default: false }
        },

        mixins: [viewOptions, resetMixin],

        data() {
            return {
                isDangerousGoods: false,
                fieldNames: FIELD_NAMES,
                selectedCustomerProduct: null,
                colliAddCount: 1,
            };
        },

        watch: {
            showColliDims: function (val) {
                this.$store.dispatch(
                    CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                );
            },
            reset() {
                this.showColliDims = this.getDefaultColliDimension;
            },
            products: {
                handler() {
                    this.reloadProducts();
                },
                deep: true,
            },
            getSelectedCompanyId: {
                handler() {
                    this.selectedCustomerProduct = null;
                    this.products = [];
                    this.reloadProducts();
                },
            },
        },

        methods: {
            isNumber($event) {
                let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                if (keyCode < 48 || keyCode > 57) {
                    $event.preventDefault();
                }
            },
            addCustomerProductColli() {
                let c = helpers.cloneObject(this.shipment.collis[0]);
                if (this.selectedCustomerProduct != null) {
                    c = {
                        packagingId: this.$store.getters[
                            CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.PACKAGINGID_BY_TYPE
                        ](this.selectedCustomerProduct.packageType),
                        weight: this.selectedCustomerProduct.weight,
                        length: this.selectedCustomerProduct.length,
                        width: this.selectedCustomerProduct.width,
                        height: this.selectedCustomerProduct.height,
                        dryIce: 0,
                        unitPrice: this.selectedCustomerProduct.unitPrice,
                        currency: this.selectedCustomerProduct.currency,
                        shipmentPackagingId: this.selectedCustomerProduct.id,
                    };
                }
                if (this.shipment.collis[0].weight === 0) {
                    this.shipment.collis.pop();
                }
                for (let index = 0; index < this.colliAddCount; index++) {
                    this.shipment.collis.push(helpers.cloneObject(c));
                }
                this.shipment.colliDetails.numberOfColli = this.shipment.collis.length;
                if (c.currency != null) {
                  this.shipment.customsAmount.currencyCode = c.currency;
                }
            },

            displayEditShipmentPackagingModal() {
                const ref = 'editModal-shipmentPackaging';
                this.$bvModal.show(ref);
            },

            reloadProducts() {
                this.selectedCustomerProduct = null;
                var list = this.$store.getters[
                    CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING
                ];
                this.products = list;
            },
        },

        computed: {
            ...mapGetters('createShipment', ['getIsColliDimension', 'getDefaultColliDimension']),
            ...mapGetters('createShipment', ['getSelectedCompanyId', 'getPrototype']),

            listOfDgTypes() {
                return this.$store.state.createShipment.dangerousGoodsTypes;
            },
            listOfCustomerProducts() {
                return this.$store.getters[
                    CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING
                ];
            },
            showColliDims: {
                get() {
                    return this.getIsColliDimension;
                },
                set(value) {
                    this.$store.dispatch(
                        CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_ISCOLLIDEMENSIONS,
                        value
                    );
                },
            },
            colliCount: {
                get() {
                    if (
                        this.$store.getters[
                        CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING_ACTIVE
                        ]
                    ) {
                        return this.colliAddCount;
                    }
                    return this.shipment.colliDetails.numberOfColli;
                },
                set(newValue) {
                    if (Number.isInteger(newValue)) {
                      if (
                          this.$store.getters[
                          CREATE_SHIPMENT_PREFIX +
                          GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING_ACTIVE
                              ]
                      ) {
                        this.colliAddCount = newValue;
                        return;
                      }
                      const count = newValue;
                      this.shipment.colliDetails.numberOfColli = count;
                      if (count <= 0) {
                        this.shipment.colliDetails.numberOfColli = 1;
                      }

                      if (this.shipment.collis.length > count && count !== 0) {
                        while (this.shipment.collis.length > count) {
                          this.shipment.collis.pop();
                        }
                      } else {
                        while (this.shipment.collis.length < count) {
                          const colliCopy = Object.assign({}, this.shipment.collis[0]);
                          this.shipment.collis.push(colliCopy);
                        }
                      }
                      if (!this.getIsColliDimension){
                        let colliWeight = this.shipment.colliDetails.totalWeight / count;
                        this.shipment.collis.forEach((colli) => {
                          colli.weight = colliWeight;
                        });
                      }

                      this.shipment.colliDetails.numberOfColli = count;
                    }
                },
            },
        },
        created() {
            this.reloadProducts();
        },
    };
</script>

<style></style>
